export default function Switch() {
  return {
    MuiSwitch: {
      styleOverrides: {}
    }
  };
}
